export const GetSetDesignMark = () => (
  <img
    src="/getsetdesign-logo.webp"
    alt="Get Set Creative Design"
    data-testid="gsd-mark"
    className="mx-auto w-full max-w-[300px] h-auto"
  />
);
